import React, { useState} from 'react';
import {Box,Typography,Container,Button} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme, alpha,styled } from '@mui/material/styles'
import { ExplicitRounded, FileOpen, Remove, TitleRounded } from '@mui/icons-material';
import ItemView from './ItemView';

const NoticeDialog = ({visible,setVisible,handleClick,children})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch()

	const onOpen = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					N.B
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{width:{xs:300,md:450},justifyContent:"center",background:theme.palette.background.default}}>

            <Box ml={4} sx={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
                <ExplicitRounded sx={{color:"red"}}/> 
                <Typography  ml={1} fontSize={12} sx={{color:"gold",fontFamily:"dinofans"}}>
                    Please, Know this !
                </Typography>            
            </Box>
            <Box>
                {children}
            </Box>
            <Box sx={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",alignItems:"center"}}>
                <Button onClick={()=>{
					handleClick()
					}} sx={{color:"maroon",background:"gold",padding:1,marginRight:2,fontFamily:"dinofans",fontSize:10}}>
                    Continue
                </Button>   
                <Button onClick={()=>{setVisible(false)}} sx={{color:"white",background:"maroon",padding:1,fontFamily:"dinofans",fontSize:10}}>
                    Cancel
                </Button>              
            </Box>

		</DialogContent>
	</Dialog>
	)
}

export default NoticeDialog;